import { render } from "./ViewPolicy.vue?vue&type=template&id=dd66794a&scoped=true"
import script from "./ViewPolicy.vue?vue&type=script&lang=js"
export * from "./ViewPolicy.vue?vue&type=script&lang=js"

import "./ViewPolicy.vue?vue&type=style&index=0&id=dd66794a&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd66794a"]])

export default __exports__